import { render, staticRenderFns } from "./ReportTotalResponses.vue?vue&type=template&id=91a3f950&scoped=true&"
import script from "./ReportTotalResponses.vue?vue&type=script&lang=js&"
export * from "./ReportTotalResponses.vue?vue&type=script&lang=js&"
import style0 from "./ReportTotalResponses.vue?vue&type=style&index=0&id=91a3f950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a3f950",
  null
  
)

export default component.exports